/**
 * Action Manifest Registry — maps action id -> ActionManifest.
 *
 * Manifests opt actions into the cross-entity resolver. Actions WITHOUT
 * a manifest continue to dispatch through `universalActionHandlers` as
 * single-entity actions (existing behavior preserved).
 */

import { logger } from "@/lib/logger";

import type { ActionManifest } from "./types";

const MANIFESTS = new Map<string, ActionManifest>();

export function registerActionManifest(manifest: ActionManifest): void {
  if (MANIFESTS.has(manifest.actionId)) {
    logger.info("overriding manifest", { actionId: manifest.actionId });
  }
  MANIFESTS.set(manifest.actionId, manifest);
}

export function getActionManifest(
  actionId: string,
): ActionManifest | undefined {
  return MANIFESTS.get(actionId);
}

export function hasActionManifest(actionId: string): boolean {
  return MANIFESTS.has(actionId);
}

export function listActionManifests(): ActionManifest[] {
  return Array.from(MANIFESTS.values());
}
